import { useLanguage } from '../../contexts/LanguageContext';
import { cn } from '../../lib/utils';

const IMG_SRC = '/brand/logos/btn_strava_connect_with_orange_x2.png';

export default function StravaConnectOrangeButton({
  onClick,
  className,
  imgClassName,
  disabled = false,
  type = 'button',
}) {
  const { t } = useLanguage();

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'inline-flex rounded-md outline-none transition-opacity hover:opacity-95 active:opacity-90',
        'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        'disabled:pointer-events-none disabled:opacity-50',
        className
      )}
    >
      <img
        src={IMG_SRC}
        alt={t('strava.connectWithStravaAlt')}
        className={cn('h-10 w-auto max-w-full object-contain sm:h-11', imgClassName)}
        decoding='async'
      />
    </button>
  );
}
